import styled from "styled-components";

export const ImportWrapper = styled.div`
  padding: 24px;
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .ant-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .ant-tabs-content-holder {
    flex: 1;
    overflow-y: auto;
  }

  .ant-steps {
    margin-bottom: 24px;
  }
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const StatCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-width: 160px;
  flex: 1;
`;

export const Section = styled.div`
  background: white;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;

  h4 {
    margin: 0 0 12px;
    font-weight: 600;
  }
`;

export const TwoColumns = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;

  > div:first-child {
    flex: 2;
    min-width: 0;
  }
  > div:last-child {
    flex: 1;
    min-width: 260px;
  }
`;

export const PurposeList = styled.ol`
  margin: 0;
  padding-left: 18px;
  line-height: 1.6;

  li + li {
    margin-top: 8px;
  }
`;

export const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;
